module.exports = ".current-user-main {\r\n}\r\n\r\n.current-user-table {\r\n    display: table;\r\n}\r\n\r\n.current-user-table-row {\r\n    display: table-row;\r\n}\r\n\r\n.current-user-table-cell {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n\r\n.current-user-name {\r\n    min-width: 350px;\r\n    vertical-align: top;\r\n}\r\n\r\n.current-user-value {\r\n}\r\n\r\n.group-list {\r\n    list-style-type: none;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/current-user/current-user.component.css
// module id = ./src/app/security/current-user/current-user.component.css
// module chunks = main